import { createContext } from 'react';
import type { OffersFilterStore } from './store';

export const OffersFilterStoreContext = createContext<OffersFilterStore | null>(null);
